<input type="text" value="{{params.value}}">
